// extracted by mini-css-extract-plugin
module.exports = {"card":"ApiCard_card__FrJHa","img":"ApiCard_img__3FvJh"};